<template>
  <div>
    <div class="row">
      <div class="col-xs-12">
        <OnRatiosEmploisSite
            :agencyId="f_agency_id"
            :pointServicesId="f_point_services_id"
            :period="f_period"
        />
      </div>
    </div>
  </div>
</template>

<script>
import OnRatiosEmploisSite from '@/components/OnRatiosEmploisSite.vue'

export default {
  name: 'OnRatiosEmploisSiteNm',
  components: {
    OnRatiosEmploisSite
  },
  data() { return {
    f_agency_id : this.$route.params.agency_id,
    f_point_services_id : this.$route.params.point_services_id,
    f_period : this.$route.params.period
  }}
}

</script>